import MicroModal from 'micromodal';

/**
 * Iframe DOM element
 * @param {string} vimeoLink vimeo video url
 * @return {HTMLElement}
 */
const iframeModalDOM = (vimeoLink) => {
  return `
    <div
      class="vimeo-modal"
      role="dialog"
      aria-hidden=true
      id="vimeo-modal"
      data-micromodal-close
    >
        <iframe
          src="${vimeoLink}"
          width="640"
          height="360"
          frameborder="0"
          allowfullscreen
          allow="autoplay; fullscreen; picture-in-picture;"
        ></iframe>
    </div>
  `;
};

const removeModal = (modalId) => {
  document.getElementById(modalId).remove();
};

const vimeo = {
  init() {
    const vimeoPlayers = document.querySelectorAll('[data-module="vimeo-player"');

    // Checks for availiabilty of Vimeo Players on the current page
    vimeoPlayers.length && vimeoPlayers.forEach((vimeoPlayer) => {
      vimeoPlayer.addEventListener('click', (event) => {
        event.preventDefault();

        const vimeoButton = event.target.closest('[data-element="vimeo-button"]');

        if (!vimeoButton) return;

        // Falls back to the `data-src` attribute if we arent using an a tag
        const vimeoUrl = vimeoButton.href || vimeoButton.dataset.src;

        const iframeModalDom = iframeModalDOM(`${vimeoUrl}&autoplay=true`);
        document.body.insertAdjacentHTML('beforeend', iframeModalDom);

        // Construct the iframe and open it up
        MicroModal.show(
          'vimeo-modal',
          {
            onClose: (modal) => removeModal(modal.id),
            openTrigger: '[data-element="vimeo-button"]',
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
          });
      });
    });
  },
};

export default vimeo;
